import page from './public/page.vue'
import moduleGroup from './public/module_group.vue'
import module from './public/module.vue'
import moduleTab from './public/module_tab.vue'
import moduleColumn from './public/module_column.vue'

import cTip from './public/tip.vue'
import cTooltip from './public/tooltip.vue'

import cTable from './table/index.vue'
import cTableColumn from './table/column.vue'
import cTableButton from './table/button.vue'

import cForm from './form/index.vue'
import cFormColumn from './form/column.vue'
import cFormItem from './form/item.vue'

import cDetail from './detail/index.vue'
import cDetailItem from './detail/item.vue'

import cInput from './unit/input.vue'
import cButton from './unit/button.vue'
import cRadio from './unit/radio.vue'
import cRadioGroup from './unit/radio_group.vue'
import cCheckbox from './unit/checkbox.vue'
import cCheckboxGroup from './unit/checkbox_group.vue'
import cSelect from './unit/select.vue'
import cDatetime from './unit/datetime.vue'
import cColor from './unit/color.vue'
import cLink from './unit/link.vue'
import cMedia from './unit/media.vue'
import cFile from './unit/file.vue'
import cEditor from './unit/editor.vue'
import cImage from './unit/image.vue'
import cSwitch from './unit/switch.vue'

import cDialog from './dialog/index.vue'

import mSearch from './module/search.vue'
import mOperate from './module/operate.vue'

// 导出组件
export default {
	install: function(Vue) {
		Vue.component('page', page);
		Vue.component('moduleGroup', moduleGroup);
		Vue.component('module', module);
		Vue.component('moduleTab', moduleTab);
		Vue.component('moduleColumn', moduleColumn);
		
		Vue.component('cTooltip', cTooltip);
		Vue.component('cTip', cTip);
		
		Vue.component('cInput', cInput);
		Vue.component('cButton', cButton);
		Vue.component('cRadio', cRadio);
		Vue.component('cRadioGroup', cRadioGroup);
		Vue.component('cCheckbox', cCheckbox);
		Vue.component('cCheckboxGroup', cCheckboxGroup);
		Vue.component('cSelect', cSelect);
		Vue.component('cDatetime', cDatetime);
		Vue.component('cColor', cColor);
		Vue.component('cLink', cLink);
		Vue.component('cMedia', cMedia);
		Vue.component('cFile', cFile);
		Vue.component('cEditor', cEditor);
		Vue.component('cImage', cImage);
		Vue.component('cSwitch', cSwitch);
		
		Vue.component('cTable', cTable);
		Vue.component('cTableColumn', cTableColumn);
		Vue.component('cTableButton', cTableButton);
		
		Vue.component('cForm', cForm);
		Vue.component('cFormColumn', cFormColumn);
		Vue.component('cFormItem', cFormItem);
		
		Vue.component('cDetail', cDetail);
		Vue.component('cDetailItem', cDetailItem);
		
		Vue.component('cDialog', cDialog);
		
		Vue.component('mSearch', mSearch);
		Vue.component('mOperate', mOperate);
    }
}